
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {mechanismApi} from "@/api/organization";
    import AddManufactory from "@/components/AddManufactory.vue";
    @Component({
        name: 'SelectMechanism',
        components: {AddManufactory}
    })
    export default class SelectMechanism extends Vue {
        @Prop()
        private value !: any;//传入的单位ID
        @Prop()
        private isAdd !: boolean; //是否未查询到单位后增加添加按钮
        @Prop()
        private source !: any; //来源 0:注册单位 1:制作的单位 2:起草单位 3:发证机关 4:发布机关
        @Prop()
        private rowIndex !: any;//下标 可以不传
        @Prop()
        private showOnly !: boolean;//只展示文字
        mechanismNameId = "";//当前选中的单位ID
        mechanism = null as any; //当前选中的单位信息
        mechanismList = [];//单位列表
        queryString = "";//模糊查询
        loading = false;//加载
        setDialog = false;
        created() {
            this.mechanismNameId = String(this.value);
        }
        cloneData(data: any){
            return JSON.parse(JSON.stringify(data));
        }
        changeMechanism(){
            if(this.mechanismNameId == '-1'){
                this.setDialog = true;
                return;
            }
            this.mechanism = this.mechanismList.find((m: any) => m.id == this.mechanismNameId);
            //向父组件发送数据
            this.sendData({
                mechanismName: this.mechanism.name,//单位别名
                mechanismNameId: this.mechanismNameId,//单位别名ID
                mechanismId: this.mechanism.mechanismId,//单位ID
                rowIndex: this.rowIndex//当前表格数据位置
            }, "changeMechanism");
        }
        sendData(data: any, mode: string){
            this.$emit('onChange', this.cloneData(data));
        }
        //清空内容
        clear(){
            this.mechanismNameId = '';
            this.mechanism = null;
            this.mechanismList = [];
            this.sendData({
                mechanismName: "",//单位别名
                mechanismNameId: "",//单位别名ID
                mechanismId: "",//单位ID
                rowIndex: this.rowIndex//当前表格数据位置
            }, "changeMechanism");
        }
        @Watch("value")
        valueChanged(val: string) {
            this.mechanismNameId = String(val);
        }
        @Watch("rowIndex")
        rowIndexChanged(val: string) {
            this.rowIndex = val;
        }
        @Watch("mechanismNameId")
        mechanismNameIdChanged(val: string) {
            this.mechanismList = [];//单位列表
            this.queryString = "";//模糊查询
            this.findMechanism();
        }
        //查询当前单位详细信息
        findMechanism() {
            if(this.mechanismNameId == 'null'){
                this.mechanismNameId = "";
                return;
            }
            if(this.mechanismNameId == '' || this.mechanismNameId == '-1') {
                return;
            }
            mechanismApi.list2({organizationNameId: this.mechanismNameId, current: 1, size: 1}).then((r) => {
                if (r.data.result === 0) {
                    const mechanism = r.data.data.records[0];
                    this.mechanism = mechanism;
                }
            });
        }
        //查询单位列表
        listMechanism(callback: any){
            mechanismApi.list2({
                source: this.source,
                organizationType : this.source == 1 ? "0007" : '',
                size: 100,
                current: 1,
                name: this.queryString
            }).then(r => {
                if(r.data.result === 0){
                    const dataList = r.data.data.records.filter((item: any) => item.id != this.mechanismNameId);
                    callback(dataList);
                }else{
                    callback([])
                }
            });
        }
        //模糊查询
        remoteMethod(queryString: string) {
            this.queryString = queryString;
            if (queryString !== '') {
                this.loading = true;
                this.listMechanism((dataList: any) => {
                    this.mechanismList = dataList;
                    this.loading = false;
                });
            } else {
                this.mechanismList = [];
            }
        }
        addSaveSuccess(e: any){
            let mechanismNameId = '';
            let mechanismId = "";
            if(e == null || e.splitName == undefined || e.splitName.length === 0){
                this.$message.error('数据异常！未找到该企业下的名称');
                return;
            }
            mechanismNameId = e.splitName[0].id;
            mechanismId = e.splitName[0].mechanismId;
            this.mechanism = e.splitName[0];
            this.setDialog = false;
            this.mechanismNameId = mechanismNameId;
            //向父组件发送数据
            this.sendData({
                mechanismName: this.mechanism.name,//单位别名
                mechanismNameId: mechanismNameId,//单位别名ID
                mechanismId: mechanismId,//单位ID
                rowIndex: this.rowIndex//当前表格数据位置
            }, "addSaveSuccess");
        }
        clostDialog() {
            this.setDialog = false;
            let mechanismNameId = '';
            if(this.mechanism){
                mechanismNameId =  this.mechanism.id
            }
            //单位别名
            this.mechanismNameId = mechanismNameId;
            //模糊查询
            this.queryString = '';
        }
    }
